import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DollarIcon from '@material-ui/icons/AttachMoneyOutlined';
import PeopleIcon from '@material-ui/icons/PeopleOutlineOutlined';
import CodeIcon from '@material-ui/icons/CodeOutlined';
import ApplicationIcon from '@material-ui/icons/DashboardOutlined';
import PortletLabel from 'components/PortletLabel';
import CloseIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import { withTranslation } from 'react-i18next';


// Component styles
import styles from './styles';

const icons = {
    order: {
        icon: <DollarIcon />,
        color: 'blue'
    },
    user: {
        icon: <PeopleIcon />,
        color: 'red'
    },
    product: {
        icon: <ApplicationIcon />,
        color: 'green'
    },
    feature: {
        icon: <CodeIcon />,
        color: 'purple'
    }
};

class UserInfo extends Component {

    handleClose = event => {

      this.props.onClose()
    };

  render() {
    const { className, classes, userData, onSelect, t } = this.props;
        const rootClassName = classNames(classes.root, className);

        let nombre_usuario = sessionStorage.getItem('user_name')
        let email = sessionStorage.getItem('email')
        let perfil = sessionStorage.getItem('profile')
        let cliente = sessionStorage.getItem('client')
        let admin=sessionStorage.getItem('admin')

        return (
            <div className={rootClassName}>
                <Fragment>
                    <div className={classes.buttonClosed}>
                      <IconButton key="close" aria-label="close" className={classes.buttonClosed} onClick={this.handleClose}><CloseIcon/></IconButton>
                    </div>
          <div className={classes.header}>
            {admin ? (
              <Typography variant="h5">{(t && typeof t === 'function') ? ((t('text.welcome') || 'Bienvenido') + ' Admin ' + admin) : ('Bienvenido Admin ' + admin)}</Typography>
            ) : (
              <Typography variant="h5">{(t && typeof t === 'function') ? ((t('text.welcome') || 'Bienvenido') + ' ' + nombre_usuario) : ('Bienvenido ' + nombre_usuario)}</Typography>
            )}
                        <div className={classes.content}>
                            <List component="div">
                                <ListItem
                                    className={classes.listItem}
                                    component="div"
                                    onClick={onSelect}
                                >
                                    <ListItemIcon>
                                        <div className={classes.listItemIcon}>
                                            <PeopleIcon />
                                        </div>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ secondary: classes.listItemTextSecondary }}
                                        primary={email}
                                        secondary=""
                                    />
                                </ListItem>
                            </List>
                        </div>
                    </div>
                    <Divider />
          <div className={classes.footer}>
            <PortletLabel style={{ padding: "2%", textTransform: "uppercase", fontFamily: "Roboto" }}
              title={`${(t && typeof t === 'function') ? (t('text.profile') || 'Perfil') : 'Perfil'}: ${perfil}`}
            />
          </div>
                </Fragment>



                {/*         {notifications.length > 0 ? (
          <Fragment>
            <div className={classes.header}>
              <Typography variant="h6">Bienvenido Daniel Díaz Retamal</Typography>
              <Typography
                className={classes.subtitle}
                variant="body2"
              >
                {notifications.length} Atentus
              </Typography>
            </div>
            <div className={classes.content}>
              <List component="div">
                {notifications.map(notification => (
                  <Link
                    key={notification.id}
                    to="#"
                    // to={notification.to}
                  >
                    <ListItem
                      className={classes.listItem}
                      component="div"
                      onClick={onSelect}
                    >
                      <ListItemIcon
                        className={classes.listItemIcon}
                        style={{ color: icons[notification.type].color }}
                      >
                        {icons[notification.type].icon}
                      </ListItemIcon>
                      <ListItemText
                        classes={{ secondary: classes.listItemTextSecondary }}
                        primary={notification.title}
                        secondary={notification.when}
                      />
                      <ArrowForwardIosIcon className={classes.arrowForward} />
                    </ListItem>
                    <Divider />
                  </Link>
                ))}
              </List>
              <div className={classes.footer}>
                <Button
                  color="primary"
                  component={Link}
                  size="small"
                  to="/notifications"
                  variant="contained"
                >
                  See all
                </Button>
              </div>
            </div>
          </Fragment>
        ) : (
          <div className={classes.empty}>
            <div className={classes.emptyImageWrapper}>
              <img
                alt="Empty list"
                className={classes.emptyImage}
                src="/images/empty.png"
              />
            </div>
            <Typography variant="h4">There's nothing here...</Typography>
          </div>
        )} */}
            </div>
        );
    }
}

UserInfo.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    onSelect: PropTypes.func
};

UserInfo.defaultProps = {
    onSelect: () => { }
};

export default withTranslation()(withStyles(styles)(UserInfo));
